import AgoraRTC from 'agora-rtc-sdk-ng';

// SDK v4 já usa Promises nativamente, não precisa de wrapper
export default AgoraRTC;
